<template>
  <div class="preview-layout">
    <v-row align="center" justify="center" no-gutters style="height: 100%; aspect-ratio: 16 / 9; max-width: 100%">
      <!-- <v-col class="mt-0 pt-0 pl-10 pr-10"> -->
      <v-col class="mt-0 pt-0 pl-0 pr-0">
        <video-player
          v-if="!isText"
          ref="videoComponent"
          @captureThumbnail="captureThumbnail"
          :options.sync="videoOptions"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VideoPlayer from '@/views/meeting/component/VideoPlayer.vue'
// import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'

export default {
  name: 'PreviewDialog',
  components: {
    VideoPlayer,
  },
  props: {
    recordType: String,
    blob: {
      type: null,
      required: true,
    },
    duration: Number,
  },
  created() {
    // Follow up clip 대체하는 경우 preview clip title 에 기존 title 추가
    if (
      this.currentClip &&
      this.currentClip['clipType'] &&
      this.currentClip['clipType'].indexOf('followUp') > -1 &&
      this.isReplaceFollowUp
    ) {
      this.clipTitle = this.currentClip['clipTitle']
    }
    this.$root.$refs.previewVideo = this
  },
  mounted() {
    if (this.blob && this.blob !== null) {
      this.blobUrl = URL.createObjectURL(this.blob)
      this.$refs.videoComponent.playPreview(this.blobUrl, this.duration, this.blob.type, this.recordType)
      // MP4 업로드 되기 전 BlobData 로 먼저 보여준다.
      this.$store.dispatch('setBlobData', {
        bolbUrl: this.bolbUrl,
        duration: this.duration,
        type: this.blob.type,
        recordType: this.recordType,
      })
    }
  },
  data() {
    return {
      clipTitle: '',
      textClip: '',
      note: '',
      videoOptions: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        playsinline: true,
        aspectRatio: '16:9',
        width: 400,
        playbackRates: [2.0, 1.75, 1.5, 1.25, 1.0, 0.75, 0.5],
        html5: {
          nativeTextTracks: false,
        },
      },
      poster: '',
      blobUrl: null,
      thumbnail: '',
      blobData: null,
      isMtCreateLoading: false,
    }
  },
  beforeDestroy() {
    if (this.blobUrl !== null) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = null
    }
  },
  methods: {
    captureThumbnail(val) {
      this.thumbnail = val
      this.$emit('captureThumbnail', val)
    },
    stopPreview() {
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
  },
  computed: {
    ...mapGetters(['currentClip', 'isReplaceFollowUp', 'currentMt', 'userInfo', 'chList', 'isQuickRecord']),
    isText() {
      return !this.blob || this.blob === null
    },
    wsInfo() {
      return this.$store.getters.selectedWsInfo
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
  },
  watch: {},
}
</script>

<style scoped>
span {
  color: white;
  font-weight: bold;
}
#preview {
  font-size: 20px;
}
#note {
  font-size: 14px;
}
#text-length {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: right;
  transform: translate(-20px, -30px);
  font-weight: normal;
  color: #869399;
}
.share-text-div {
  background: #1a272e;
  width: 100%;
  height: 200px;
  display: inline-block;
  vertical-align: middle;
}
.el-textarea >>> .el-textarea__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.textClip >>> .el-textarea__inner {
  background: #1a272e;
  text-align: center !important;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  resize: none;
}
.el-input >>> .el-input__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.input-div {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  background: #1a272e;
}

.row-thumbnail >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
</style>
